import { render } from "./MessageClubForm.vue?vue&type=template&id=078cc065"
import script from "./MessageClubForm.vue?vue&type=script&lang=js"
export * from "./MessageClubForm.vue?vue&type=script&lang=js"

import "./MessageClubForm.vue?vue&type=style&index=0&id=078cc065&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__